import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.thead``

const StickyContainer = styled(Container)`
  position: relative;
  th {
    position: sticky;
    top: -1.5rem;
    z-index: 2;
  }
`

/** TableHeaderRow renders a <thead> which optionally supports
 * being sticky, by applying appropriate styles to nested <th>
 * cells, since table rows themselves can't be sticky. */
const TableHeaderRow = ({ children, sticky = false }) => {
  const THEAD = sticky ? StickyContainer : Container
  return (
    <THEAD>
      <tr>{children}</tr>
    </THEAD>
  )
}

TableHeaderRow.propTypes = {
  // The "title" content
  children: PropTypes.any,
  // If true, any nested header cells stay sticky at the top of the page
  sticky: PropTypes.bool,
}

export default TableHeaderRow
